import { Box, Typography, LinearProgress } from '@mui/material';
import { styled } from '@mui/material/styles';

const ProgressCard = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: 'white',
  borderRadius: theme.spacing(2),
  border: '1px solid #EAECEF'
}));

const StyledLinearProgress = styled(LinearProgress)({
  height: 8,
  borderRadius: 4,
  backgroundColor: '#E5E7EB',
  '& .MuiLinearProgress-bar': {
    backgroundColor: '#4A90E2',
    borderRadius: 4
  }
});

interface SurveyProgressBarProps {
  currentStep: number;
  totalSteps: number;
  stepLabel: string;
}

const SurveyProgressBar = ({
  currentStep,
  totalSteps,
  stepLabel
}: SurveyProgressBarProps) => {
  const progress = (currentStep / totalSteps) * 100;

  return (
    <ProgressCard>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
        <Typography
          variant="body1"
          sx={{
            fontWeight: 500,
            fontSize: '1rem',
            color: 'text.primary'
          }}
        >
          Step {currentStep} of {totalSteps}: {stepLabel}
        </Typography>
      </Box>
      <StyledLinearProgress variant="determinate" value={progress} />
    </ProgressCard>
  );
};

export default SurveyProgressBar;

